import { Navigate } from 'react-router-dom'

import UnitDetails from './components/course/UnitDetails'
import DashboardLayout from './components/DashboardLayout'
import MainLayout from './components/MainLayout'
import SubtitleEditor from './components/shared/SubtitleEditor/OldSubtitleEditor'
import Account from './pages/Account'
import BannerList from './pages/BannerList'
import ChapterList from './pages/ChapterList'
import UnitList from './pages/CourseList'
import CustomerList from './pages/CustomerList'
import Dashboard from './pages/Dashboard'
import EntertainmentVideoList from './pages/EntertainmentVideoList'
import EntertainmentVocabularyList from './pages/EntertainmentVocabularyList'
import EntertainmentTranscriptionList from './pages/exercise/EntertainmentTranscriptionList'
import ExerciseDetailList from './pages/exercise/ExerciseDetailList'
import ExerciseMasterList from './pages/exercise/ExerciseMasterList'
import LanguageList from './pages/LanguageList'
import LessonList from './pages/LessonList'
import Login from './pages/Login'
import MediaLibraryList from './pages/media/MediaLibraryList'
import NotFound from './pages/NotFound'
import NotificationList from './pages/NotificationsList'
import ProductList from './pages/ProductList'
import ReportList from './pages/ReportList'
import ServiceLogList from './pages/ServiceLogList'
import Settings from './pages/Settings'
import UserFeedbacksList from './pages/UserFeedbacksList'
import VideoCategoryList from './pages/VideoCatogoryList'

const routes = isLoggedIn => {
  let navigateToLandingPage = undefined
  const landingPath = window.localStorage.getItem('landingPath')
  if (!isLoggedIn && window.location.pathname.indexOf('login') === -1) {
    window.localStorage.setItem(
      'landingPath',
      window.location.pathname + window.location.search
    )
  } else if (landingPath && landingPath !== '/') {
    navigateToLandingPage = landingPath
  }

  const authSucess =
    (window.localStorage?.authInfo && JSON.parse(window.localStorage?.authInfo)?.success) ||
    false

  return [
    {
      path: '/app',
      element:
        isLoggedIn || authSucess ? (
          <DashboardLayout />
        ) : (
          <Navigate to="/login" />
        ),
      children: [
        // General Module
        { path: 'dashboard', element: <Dashboard /> },
        { path: 'languages', element: <LanguageList /> },
        { path: 'banners', element: <BannerList /> },

        // Content Module
        { path: 'courses', element: <UnitList /> },
        { path: 'chapters', element: <ChapterList /> },
        { path: 'lessons', element: <LessonList /> },
        {
          path: 'practice-list',
          element: <ExerciseMasterList />,
        },
        {
          path: 'practice-item',
          element: <ExerciseDetailList />,
        },

        // Media Module
        {
          path: 'media/images',
          element: <MediaLibraryList key="images" libraryKey="images" />,
        },
        {
          path: 'media/audio',
          element: <MediaLibraryList key="audio" libraryKey="audio" />,
        },
        {
          path: 'media/videos',
          element: <MediaLibraryList key="videos" libraryKey="videos" />,
        },

        { path: 'account', element: <Account /> },
        { path: 'customers', element: <CustomerList /> },
        { path: 'unit-details', element: <UnitDetails /> },
        { path: 'reports', element: <ReportList /> },
        { path: 'notifications', element: <NotificationList /> },

        {
          path: '4l-videos',
          element: <EntertainmentVideoList />,
        },
        {
          path: '4l-categories',
          element: <VideoCategoryList />,
        },
        {
          path: 'entertainmentTranscriptions',
          element: <EntertainmentTranscriptionList />,
        },
        {
          path: 'entertainmentVocabularies',
          element: <EntertainmentVocabularyList />,
        },
        {
          path: 'feedbacks',
          element: <UserFeedbacksList />,
        },
        {
          path: 'servicelogs',
          element: <ServiceLogList />,
        },
        { path: 'products', element: <ProductList /> },
        { path: 'settings', element: <Settings /> },
        { path: 'subtitleEditor', element: <SubtitleEditor /> },
        //{ path: "/", element: <Navigate to="/app/dashboard" /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '/',
      element: !isLoggedIn ? (
        <MainLayout />
      ) : navigateToLandingPage &&
        window.localStorage.getItem('landingPath') ? (
        <Navigate to={window.localStorage.getItem('landingPath')} />
      ) : (
        <Navigate to="/app/dashboard" />
      ),
      children: [
        { path: 'login', element: <Login /> },
        { path: '/', element: <Navigate to="/login" /> },
        { path: '404', element: <NotFound /> },
        // { path: "*", element: <Navigate to="/404" /> },
      ],
    },
  ]
}

export default routes
